<template>
    <v-dialog
        v-model="addEmailAddressDialog"
        persistent
        width="500"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-if="modelType==='Add'"
                class="ml-3 action-btn text-subtitle-2"
                depressed
                color="primary"
                v-bind="attrs"
                @click="openDialog"
            >
                + Add E-mail Address
            </v-btn>
            <v-icon
                v-if="modelType==='Edit'"
                class="cp"
                v-bind="attrs"
                @click="openDialog"
            >
                mdi-pencil-outline
            </v-icon>
        </template>
        <v-card id="add_email_address_dialog">
            <v-card-title class="text-h5 lighten-2">
                <span>Add E-mail Address</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <v-form
                    ref="form"
                    v-model="valid"
                >
                    <v-row class="mt-2">
                        <v-col class="col col-md-12">
                            Please specify the E-mail address.
                        </v-col>
                    </v-row>
                    <v-row class="mx-1 mt-6">
                        <v-col class="col col-md-12 p-0">
                            <v-text-field
                                v-model="name"
                                outlined
                                dense
                                placeholder="Name"
                                label="Name"
                                :rules="nameRules"
                                required
                            />
                        </v-col>
                    </v-row>
                    <v-row class="mx-1">
                        <v-col class="col col-md-12 p-0">
                            <v-text-field
                                v-model="email"
                                outlined
                                dense
                                placeholder="E-mail Address"
                                label="E-mail Address"
                                :rules="emailRules"
                                required
                            />
                        </v-col>
                    </v-row>
                    <v-row class="ml-1">
                        <v-col class="col col-md-12 p-0">
                            <v-checkbox
                                v-model="enabled"
                                label="Enabled"
                            />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn
                    style="text-transform: none !important"
                    outlined
                    light
                    @click="closedDialog"
                >
                    Cancel
                </v-btn>
                <v-btn
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    :disabled="!valid"
                    @click="saveEmail"
                >
                    Add
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>
<script>
export default {
    name: 'AddEmailAddress',
    props: {
        modelType: {
            type: String,
            required: true
        },
        emailDetails: {
            type: Object,
            required: false,
            default: () => {}

        }
    },
    data: () => ({
        addEmailAddressDialog: false,
        valid: false,
        enabled: false,
        name: null,
        nameRules: [
            v => !!v || 'Name is required',
        ],
        email: null,
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        rowid: null
    }),
    methods: {
        closedDialog() {
            this.addEmailAddressDialog = false;
            this.enabled = null;
            this.name = null;
            this.email = null;
            this.rowid = null;
        },
        openDialog() {
            this.addEmailAddressDialog = true;
            this.valid = false;
            if(this.modelType === 'Add') {
                this.enabled = false;
                this.name = null;
                this.email = null;
                this.rowid = null;
            } else if(this.modelType === 'Edit') {
                this.enabled = this.emailDetails.enabled;
                this.name = this.emailDetails.name;
                this.email = this.emailDetails.email;
                this.rowid = this.emailDetails.rowid;
            }
        },
        saveEmail() {
            this.$emit('add-email-address', {
                enabled: this.enabled,
                name: this.name,
                email: this.email,
                rowid: this.rowid
            });
            this.closedDialog();
        },
    }
};
</script>
<style>

</style>